export enum VarKey { 
  PERSON_NAME = 'Entity personName',
  EMAIL = 'Entity email',
  PHONENUMBER = 'Entity phonenumber',
  USER_ADDRESS_LINE_1 = 'UserAddressLine1',
  USER_ADDRESS_LINE_2 = 'UserAddressLine2',
  USER_CITY = 'UserCity',
  USER_STATE = 'UserState',
  USER_ZIP = 'UserZip',
  USER_LAST_INTENT = 'UserLastIntent',
  USER_COUNTRY_CODE = 'UserCountryCode',
  USER_HAS_COMPLETED_PROFILE = 'UserHasCompletedProfile',
  USER_HAS_CONFIRMED_PROFILE = 'UserHasConfirmedProfile',
  USER_HAS_SHORT_PROFILE = 'User_HasShortProfile',
  USER_ANSWERING_MACHINE = 'UserAnsweringMachine',
  USER_PERSONA = 'UserPersona',
  USER_HAS_UNHANDLED = 'UserHasUnhandled',
  USER_ACCOUNT_TYPE = 'UserAccountType',
  USER_CRM_ID = 'UserCRMId',
  USER_CRM_STATUS = 'UserCRMStatus',
  USER_LAST_AGENT_NAME = 'UserLastAgentName',
  USER_LEADHAS_SENT_EMAIL_RECEIPT = 'UserLeadhasSentEmailReceipt',
  USER_LEADHAS_SENT_TO_FMS = 'UserLeadhasSentToFMS',
  USER_REVIEW_NPS_SCORE = 'UserReviewNPSScore',
  USER_REVIEW_NPS_FEEDBACK = 'UserReviewNPSFeedback',
  USER_REVIEW_NPS_TOPIC = 'UserReviewNPSTopic',
  USER_TEMPORARY_FMSID = 'UserTemporaryFMSID',
  USER_REVIEW_FEEDBACK_PERSONA = 'UserReviewFeedbackPersona',
  USERHAS_SEEN_FEATURE_MENU = 'UserhasSeenFeatureMenu',
  USERHAS_SEEN_INVENTORY_MENU = 'UserhasSeenInventoryMenu',
  USERHAS_SEEN_ANYTHING_ELSE_MENU = 'UserhasSeenAnythingElseMenu',
  USERHAS_SEEN_COST_MENU = 'UserhasSeenCostMenu',
  USERHAS_SEEN_CONTACT_MENU = 'UserhasSeenContactMenu',
  USERHAS_SEEN_SIZE_MENU = 'UserhasSeenSizeMenu',
  USERHAS_SEEN_PROBLEM_MENU = 'UserhasSeenProblemMenu',
  USERHAS_SEEN_ACCOUNT_MENU = 'UserhasSeenAccountMenu',
  USERHAS_SEEN_CHANGE_ACCOUNT_MENU = 'UserhasSeenChangeAccountMenu',
  USERHAS_SEEN_ACCOUNT_LOGIN_MENU = 'UserhasSeenAccountLoginMenu',
  USERHAS_SEEN_PURCHASE_PROCESS_MENU = 'UserhasSeenPurchaseProcessMenu',
  USERHAS_SEEN_LEASE_TERMS_MENU = 'UserhasSeenLeaseTermsMenu',
  USERHAS_SEEN_MOVE_MENU = 'UserhasSeenMoveMenu',
  USERHAS_SEEN_GS_EXISTING_MENU = 'UserhasSeenGSExistingMenu',
  USERHAS_SEEN_GS_POTENTIAL_MENU = 'UserhasSeenGSPotentialMenu',
  USERHAS_SEEN_SMS_DISCLAIMER = 'UserhasSeenSMSDisclaimer',
  USER_CRON_RECEIPT_TYPE = 'UserCronReceiptType',
  USER_AFTER_NAVIGATE_HOLDER = 'UserAfterNavigateHolder',
  USER_PROFILE_COLLECT_HOLDER = 'UserProfileCollectHolder',
  USER_PREVIOUS_CHANNEL_HOLDER = 'UserPreviousChannelHolder',
  USER_WANT_TO_SEARCH_ANOTHER_STORE = 'User_WantToSearchAnotherStore',
  USER_HAS_PROVIDED_FEEDBACK = 'User_hasProvidedFeedback',
  USER_IS_UPDATING_PROFILE = 'User_isUpdatingProfile',
  USER_SELECTED_STORE_FROM_SMS = 'User_selectedStoreFromSMS',
  USER_TENANT_ID = 'UserTenantId',
  USER_FMS_ERROR = 'UserFMSError',
  USER_LEAD_STATUS = 'UserLeadStatus',
  USER_EMAIL_TYPE = 'UserEmailType',
  USER_EMAIL_RECEIPT_TYPE = 'UserEmailReceiptType',
  USER_ACCESS_CODE = 'UserAccessCode',
  USER_ACCOUNT_STATUS = 'UserAccountStatus',
  USER_ACCOUNT_PAYMENT_STATUS = 'UserAccountPaymentStatus',
  USER_PAYMENT_DUE_DATE = 'UserPaymentDueDate',
  USER_AUTO_PAY_ENABLED = 'UserAutoPayEnabled',
  USER_DAYS_PAST_DUE = 'UserDaysPastDue',
  USER_WANTS_TO_STORE_VEHICLE = 'UserWantsToStoreVehicle',
  USER_WANT_TO_SHOP_BY_PRICE = 'UserWantToShopByPrice',
  USER_FILTER_FEATURES = 'UserFilterFeatures',
  USER_FILTER_SIZE = 'UserFilterSize',
  USER_NOTES = 'UserNotes',
  USER_UNIT_NUMBER = 'UserUnitNumber',
  USER_UNIT_SIZE = 'UserUnitSize',
  USER_UNIT_FEATURES = 'UserUnitFeatures',
  USER_ACCOUNT_BALANCE = 'User_AccountBalance',
  USER_IN_ABANDONED_CART_WORKFLOW = 'UserinAbandonedCartWorkflow',
  USER_INTERRUPTED_PROFILE_COLLECT = 'UserInterruptedProfileCollect',
  USER_IS_MOBILE = 'UserIsMobile',
  USER_REFERRED_BY = 'UserReferredBy',
  USER_REFERRED_BY_NAME = 'UserReferredByName',
  User_Sentiment = 'User_Sentiment',
  User_SentimentScore = 'User_SentimentScore',
  UserIncomingCallNumber = 'UserIncomingCallNumber',
  STORE_LOCATION_NUMBER = 'StoreLocationNumber',
  STORE_ID = 'StoreId',
  STORE_FMS_INTEGRATION_ID = 'StoreFMSIntegrationId',
  STORE_FMS_TYPE = 'StoreFMSType',
  STORE_NAME = 'StoreName',
  STORE_ADDRESS_LINE_1 = 'StoreAddressLine1',
  STORE_CITY = 'StoreCity',
  STORE_STATE = 'StoreState',
  STORE_POSTAL_CODE = 'StorePostalCode',
  STORE_PHONE_NUMBER = 'StorePhoneNumber',
  STORE_PAY_BY_PHONE_NUMBER = 'StorePayByPhoneNumber',
  STORE_AFTER_HOURS_PHONE_NUMBER = 'StoreAfterHoursPhoneNumber',
  STORE_EMAIL = 'StoreEmail',
  STORE_DM_NAME = 'StoreDMName',
  STORE_DM_EMAIL = 'StoreDMEmail',
  STORE_WEBSITE_URL = 'StoreWebsiteUrl',
  STORE_URL_LOOKUP_PATTERN = 'StoreUrlLookupPattern',
  STORE_PHOTO_URL = 'StorePhotoURL',
  STORE_WALLET_PASS_URL = 'StoreWalletPassURL',
  STORE_PAYMENT_URL = 'StorePaymentURL',
  STORE_MAP_URL = 'StoreMapURL',
  STORE_OFFICE_HOURS = 'StoreOfficeHours',
  STORE_ACCESS_HOURS = 'StoreAccessHours',
  STORE_CALL_CENTER_HOURS = 'StoreCallCenterHours',
  STORE_PAYMENT_OPTIONS = 'StorePaymentOptions',
  STORE_RV_STORAGE = 'StoreRVStorage',
  STORE_SMALL_VEHICLE_STORAGE = 'StoreSmallVehicleStorage',
  STORE_TRAILER_STORAGE = 'StoreTrailerStorage',
  STORE_DELIVERIES_ACCEPTED = 'StoreDeliveriesAccepted',
  STORE_VIDEO_SURVEILLANCE = 'StoreVideoSurveillance',
  STORE_SECURITY_AMENITIES = 'StoreSecurityAmenities',
  STORE_DRIVE_UP_UNITS = 'StoreDriveUpUnits',
  STORE_CLIMATE_CONTROLLED_UNITS = 'StoreClimateControlledUnits',
  STORE_HEATED_UNITS = 'StoreHeatedUnits',
  STORE_OFFICE_SPACE = 'StoreOfficeSpace',
  STORE_CONFERENCE_ROOM = 'StoreConferenceRoom',
  STORE_TRUCK_RENTALS = 'StoreTruckRentals',
  STORE_TWENTY_FOUR_HOUR_ACCESS = 'StoreTwentyFourHourAccess',
  STORE_LOCKERS_AVAILABLE = 'StoreLockersAvailable',
  STORE_LOCK_TYPES = 'StoreLockTypes',
  STORE_TRUCK_TYPES = 'StoreTruckTypes',
  STORE_PARKING_TYPE = 'StoreParkingType',
  STORE_LOADING_AREA_TYPE = 'StoreLoadingAreaType',
  STORE_LEAD_UNIT_ID = 'StoreLeadUnitId',
  STORE_APPOINTMENT_AVAILABLE = 'StoreAppointmentAvailable',
  STORE_GOOGLE_REVIEW_URL = 'StoreGoogleReviewURL',
  STORE_CLIMATE_CONTROL_DISPLAY_NAME = 'StoreClimateControlDisplayName',
  STORE_INSURANCE_DISPLAY_NAME = 'StoreInsuranceDisplayName',
  STORE_HAS_ELEVATOR = 'StoreHasElevator',
  STORE_HAS_WINE_STORAGE = 'StoreHasWineStorage',
  STORE_HAS_GUN_STORAGE = 'StoreHasGunStorage',
  STORE_GOOGLE_PLACE_ID = 'StoreGooglePlaceId',
  STORE_GOOGLE_ACCOUNT_AND_LOCATION_NAME = 'StoreGoogleAccountAndLocationName',
  STORE_HAS_BOAT_STORAGE = 'StoreHasBoatStorage',
  STORE_BRAND_ID = 'StoreBrandId',
  STORE_COUNTRY_CODE = 'StoreCountryCode',
  STORE_ONLY_SHOW_UNIT_DIMENSIONS = 'StoreOnlyShowUnitDimensions',
  STORE_SPOT_LOCATION_SLUG = 'StoreSpotLocationSlug',
  STORE_SPOT_LINK_SLUG = 'StoreSpotLinkSlug',
  SPACE_ID = 'SpaceId',
  SPACE_NAME = 'SpaceName',
  SPACE_DIMENSIONS = 'SpaceDimensions',
  SPACE_RATE = 'SpaceRate',
  SPACE_HAS_CLIMATE_CONTROL = 'SpaceHasClimateControl',
  SPACE_IS_INSIDE = 'SpaceIsInside',
  SPACE_IS_UPPER_STACK = 'SpaceIsUpperStack',
  SPACE_IS_LOWER_STACK = 'SpaceIsLowerStack',
  SPACE_HAS_POWER = 'SpaceHasPower',
  SPACE_FLOOR = 'SpaceFloor',
  SPACE_IS_PARKING = 'SpaceIsParking',
  SPACE_IS_DRIVE_UP = 'SpaceIsDriveUp',
  SPACE_HAS_ELEVATOR_ACCESS = 'SpaceHasElevatorAccess',
  SPACE_HAS_ALARM = 'SpaceHasAlarm',
  SPACE_FEATURES = 'SpaceFeatures',
}